import React from "react";

export default function SectionLabel({ number, children, className = "" }) {
  return (
    <div className={`flex items-center gap-3 mb-5 ${className}`}>
      <div className="flex items-center gap-2 glass-pill rounded-full pl-1.5 pr-4 py-1.5">
        {number && (
          <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-gradient-to-br from-emerald-600 to-emerald-700 text-white text-[10px] font-semibold">
            {number}
          </span>
        )}
        <span className="text-[11px] uppercase tracking-[0.25em] text-emerald-700">
          {children}
        </span>
      </div>
      <div className="h-px flex-1 max-w-[120px] bg-gradient-to-r from-emerald-600/60 to-transparent" />
    </div>
  );
}
